"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeFiles_de_de = void 0;
function backofficeFiles_de_de() {
    return {
        "backoffice.files.title": "Dateien",
        "backoffice.files.projectspecific": "Projektspezifische Dateien des Projektes ",
        "backoffice.files.global": "Projektübergreifende Datein der Firma ",
        "backoffice.files.filename": "Name",
        "backoffice.files.filesize": "Dateigröße",
        "backoffice.files.filetype": "Dateityp",
        "backoffice.files.createdat": "Erstellt",
        "backoffice.files.lastmodified": "Zuletzt geändert",
        "backoffice.files.openoriginal": "Datei herunterladen",
        "backoffice.files.copydownloadurl": "Download-Link kopieren",
        "backoffice.files.deletefile": "Datei löschen",
        "backoffice.files.listempty": "Es wurden noch keine Dateien hochgeladen...",
        "backoffice.files.emptytitle": "Keine Dateien gefunden...",
        "backoffice.files.emptymessage": "Es wurden noch keine Dateien hochgeladen",
        "backoffice.files.showqr": "Download-Link als QR Code",
        "backoffice.files.license": "Lizenz",
        "backoffice.files.licenseurl": "Lizenz-URL",
        "backoffice.files.onlinesearch": "ONLINE SUCHE",
        "backoffice.files.onlineimgsearch": "Online Bilder Suche",
        "backoffice.files.entersearchterm": "Suchbegriff eingeben...",
        "backoffice.files.nosearchresults": "Keine Suchresultate",
        "backoffice.files.saveimg": "Bild speichern:",
        "backoffice.files.imgsize.full": "Groß",
        "backoffice.files.imgsize.regular": "Standard",
        "backoffice.files.imgsize.small": "Klein"
    };
}
exports.backofficeFiles_de_de = backofficeFiles_de_de;
